import { Box, Divider, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ArrowLeft2 } from "iconsax-react";
import { useTranslation } from "react-i18next";

import { getRoleDefinition } from "@/lib/settings/access";
import type { SettingsSidebarLayoutProps } from "./SettingsSidebar.template.types";
import * as styles from "./SettingsSidebar.template.styles";

export type { SettingsSidebarLayoutProps, SettingsTab } from "./SettingsSidebar.template.types";

export function SettingsSidebarTemplate({
  tabs,
  activeTab,
  onTabChange,
  roleKey,
  roleLabel,
  tabCountLabel,
}: SettingsSidebarLayoutProps) {
  const { t } = useTranslation("settings");
  const theme = useTheme();
  const roleDefinition = getRoleDefinition(roleKey);
  const RoleIcon = roleDefinition.icon;

  return (
    <Box component="nav" sx={styles.sidebar}>
      {tabs.map((tab) => {
        const isActive = tab.id === activeTab;
        return (
          <Box
            key={tab.id}
            component="button"
            type="button"
            sx={styles.tabItem(isActive)}
            onClick={() => onTabChange(tab.id)}
          >
            {tab.icon}
            <Typography component="span" sx={styles.tabLabel}>
              {tab.label}
            </Typography>
            {isActive ? (
              <ArrowLeft2 size={15} variant="Linear" color={theme.palette.primary.main} />
            ) : null}
          </Box>
        );
      })}

      <Divider sx={styles.sidebarDivider} />

      <Box sx={styles.roleFooter}>
        <Box sx={styles.roleIconWrap}>
          <RoleIcon size={15} variant="Bold" color={theme.palette.primary.main} />
        </Box>
        <Box sx={styles.roleTextBlock}>
          <Typography sx={styles.roleTitle}>{t(roleLabel)}</Typography>
          <Typography sx={styles.roleSubtitle}>
            {t("roles.accessibleSections", { count: tabCountLabel })}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
